export const STYLES = {
  // ProblemContentUI
  problemContentContainer: {
    width: "50vw",
    height: "100%",
    mx: "auto",
    color: "black",
  } as const,
  problemContentHeaderContainer: {
    position: "sticky",
    top: 0,
    backgroundColor: "primary.light",
    zIndex: 15,
    pt: 2,
    pb: 1,
    mt: 0,
  } as const,
  problemTags: {
    height: "24px",
    borderRadius: "8px",
    backgroundColor: "secondary.main",
    "& .MuiChip-label": {
      fontSize: "0.75rem",
      fontWeight: 400,
      color: "secondary.contrastText",
    },
  } as const,
};
